/** Shown under first-load spinners — Render’s free plan can take ~1 min to wake. */
export const COLD_START_LOADING_HINT =
  "Hang tight! The first load can take about a minute while the free server wakes up.";
